import { BaseMapper } from '../shared/base.mapper';
import { Contact } from '../../types/admon/contact.type';

export class ContactMapper extends BaseMapper<Contact> {

}
